import styled from '@emotion/styled';
import { isFirefox } from '@core/userAgent';
//Circle button with black background and white plus sign for add to cart
export const AddToCartInnerButton = styled.button `
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 16px;
  width: 32px;
  height: 32px;
  font-size: 23px;
  line-height: 0;
  background-color: var(--player-deck-cta-button-color, #222325);
  color: var(--player-deck-cta-background-color, white) !important;
  border: none;
  cursor: pointer;
  align-self: center;
  justify-self: center;
  flex-shrink: 0;
  padding: 0;

  &[disabled] {
    opacity: 0.5;
  }

  // Firefox doesn't know what "center" means
  ${isFirefox
    ? `
    span {
      transform: translateY(-2px);
    }
    `
    : ''}
`;
export const AddToCartButtonWrapper = styled.div `
  height: 32px;
  width: 32px;
  margin-right: 14px;
`;
